const MARKETING_PROJECT_MANAGEMENT_TYPES = [{
  label: 'Task Setup',
  value: 1,
  key: 1,
  icon: 'TaskFilled',
  color: '#43a047',
  background: 'rgba(200,230,201,0.16)'
}, {
  label: 'Timeline Plan',
  value: 2,
  key: 2,
  icon: 'StoryFilled', // Timelines = narratives
  color: '#6d4c41',
  background: 'rgba(215,204,200,0.16)'
}, {
  label: 'Team Assign',
  value: 3,
  key: 3,
  icon: 'SubtaskFilled',
  color: '#00897b',
  background: 'rgba(178,223,219,0.16)'
}, {
  label: 'Budget Track',
  value: 4,
  key: 4,
  icon: 'FeatureRequestFilled', // Budget allocation as "request"
  color: '#f9a825',
  background: 'rgba(255,241,118,0.16)'
}];
const CONTENT_MANAGEMENT_TYPES = [{
  label: 'Content Plan',
  value: 1,
  key: 1,
  icon: 'FeatureRequestFilled',
  color: '#7cb342',
  background: 'rgba(220,237,200,0.16)'
}, {
  label: 'Copy Write',
  value: 2,
  key: 2,
  icon: 'SubtaskFilled',
  color: '#00695c',
  background: 'rgba(178,223,219,0.16)'
}, {
  label: 'Design Brief',
  value: 3,
  key: 3,
  icon: 'ImprovementsFilled',
  color: '#ab47bc',
  background: 'rgba(225,190,231,0.16)'
}, {
  label: 'Publish',
  value: 4,
  key: 4,
  icon: 'StoryFilled',
  color: '#1976d2',
  background: 'rgba(144,202,249,0.16)'
}];
const EMAIL_CAMPAIGN_TYPES = [{
  label: 'Newsletter',
  value: 1,
  key: 1,
  icon: 'StoryFilled',
  color: '#0288d1',
  background: 'rgba(144,202,249,0.16)'
}, {
  label: 'Promo Mail',
  value: 2,
  key: 2,
  icon: 'TaskFilled',
  color: '#f57c00',
  background: 'rgba(255,224,178,0.16)'
}, {
  label: 'Follow-up',
  value: 3,
  key: 3,
  icon: 'SupportFilled',
  color: '#2e7d32',
  background: 'rgba(200,230,201,0.16)'
}, {
  label: 'Drip Mail',
  value: 4,
  key: 4,
  icon: 'SubtaskFilled',
  color: '#8e24aa',
  background: 'rgba(225,190,231,0.16)'
}];
const EVENT_PLANNING_TYPES = [
  {
    label: "Webinar",
    value: 1,
    key: 1,
    icon: "QueryFilled",
    color: "#8DAA5B",
    background: "rgba(141, 170, 91, 0.1)"
  },
  {
    label: "Concert",
    value: 2,
    key: 2,
    icon: "FeatureRequestFilled",
    color: "#4C4C87",
    background: "rgba(76, 76, 135, 0.1)"
  },
  {
    label: "Meetup",
    value: 3,
    key: 3,
    icon: "ImprovementsFilled",
    color: "#F26430",
    background: "rgba(242, 100, 48, 0.1)"
  },
  {
    label: "Training",
    value: 4,
    key: 4,
    icon: "SupportFilled",
    color: "#5A9BD4",
    background: "rgba(90, 155, 212, 0.1)"
  },
  {
    label: "Interview",
    value: 5,
    key: 5,
    icon: "TaskFilled",
    color: "#C96F6F",
    background: "rgba(201, 111, 111, 0.1)"
  },
  {
    label: "Workshop",
    value: 6,
    key: 6,
    icon: "ImprovementsFilled",
    color: "#A678D1",
    background: "rgba(166, 120, 209, 0.1)"
  },
  {
    label: "Seminar",
    value: 7,
    key: 7,
    icon: "TaskFilled",
    color: "#E6A157",
    background: "rgba(230, 161, 87, 0.1)"
  },
  {
    label: "Discussion",
    value: 8,
    key: 8,
    icon: "SupportFilled",
    color: "#3F7C85",
    background: "rgba(63, 124, 133, 0.1)"
  },
  {
    label: "Hackathon",
    value: 9,
    key: 9,
    icon: "TaskFilled",
    color: "#7E5F9E",
    background: "rgba(126, 95, 158, 0.1)"
  },
  {
    label: "Pitch",
    value: 10,
    key: 10,
    icon: "TaskFilled",
    color: "#D75A4A",
    background: "rgba(215, 90, 74, 0.1)"
  },
  {
    label: "Roundtable",
    value: 11,
    key: 11,
    icon: "SupportFilled",
    color: "#5C8D89",
    background: "rgba(92, 141, 137, 0.1)"
  },
  {
    label: "Confurence",
    value: 12,
    key: 12,
    icon: "SupportFilled",
    color: "#BC804E",
    background: "rgba(188, 128, 78, 0.1)"
  }
];





const MARKETING_TYPES = [{
  label: 'Strategy',
  value: 1,
  key: 1,
  icon: 'EpicFilled', // Long-term plan
  color: '#283593',
  background: 'rgba(197,202,233,0.16)'
}, {
  label: 'Branding',
  value: 2,
  key: 2,
  icon: 'StoryFilled', // Messaging, perception
  color: '#6a1b9a',
  background: 'rgba(209,196,233,0.16)'
}, {
  label: 'Research',
  value: 3,
  key: 3,
  icon: 'BugFilled', // Discovery, investigation
  color: '#2e7d32',
  background: 'rgba(165,214,167,0.16)'
}, {
  label: 'Analytics',
  value: 4,
  key: 4,
  icon: 'TaskFilled', // Data processing task
  color: '#0288d1',
  background: 'rgba(144,202,249,0.16)'
}];

const CAMPAIGN_MANAGEMENT_TYPES = [{
  label: 'Ad Setup',
  value: 1,
  key: 1,
  icon: 'TaskFilled', // Simple unit
  color: '#ef6c00',
  background: 'rgba(255,224,178,0.16)'
}, {
  label: 'Target Group',
  value: 2,
  key: 2,
  icon: 'BugFilled', // Focus area
  color: '#c62828',
  background: 'rgba(255,171,145,0.16)'
}, {
  label: 'Channel Plan',
  value: 3,
  key: 3,
  icon: 'StoryFilled',
  color: '#5e35b1',
  background: 'rgba(209,196,233,0.16)'
}, {
  label: 'Launch Plan',
  value: 4,
  key: 4,
  icon: 'EpicFilled',
  color: '#1565c0',
  background: 'rgba(144,202,249,0.16)'
}];


export {
  MARKETING_TYPES,
  MARKETING_PROJECT_MANAGEMENT_TYPES,
  CAMPAIGN_MANAGEMENT_TYPES,
  CONTENT_MANAGEMENT_TYPES,
  EMAIL_CAMPAIGN_TYPES,
  EVENT_PLANNING_TYPES
};
  